import { Navigate, useOutlet } from "react-router-dom";
export const ProtectedLayout = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  console.log(userData, "userData");
  const outlet = useOutlet();

  if (!userData) {
    return <Navigate to="/login" />;
  }

  return <div>{outlet}</div>;
};

export const AuthProtectedLayout = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  console.log(userData, "userData");
  const outlet = useOutlet();

  if (userData) {
    return <Navigate to="/" />;
  }

  return <div>{outlet}</div>;
};
